import { BrandPickerDialog, closeBrandPickerDialog, type BrandPickerValue } from '@/app/entities/brands/ui'

import { useUpdateProductBrand } from '../../model'

export const PRODUCT_BRAND_MODAL_ID = 'product-brand-modal'

type ProductBrandModalProps = {
    currentBrand: BrandPickerValue
}

export const ProductBrandModal = ({ currentBrand }: ProductBrandModalProps) => {
    const { mutate: updateProductBrand, isPending, isError, error } = useUpdateProductBrand()

    const handleSave = (brand: BrandPickerValue) => {
        if (isPending) return

        updateProductBrand(brand?.id ?? null, {
            onSuccess: () => closeBrandPickerDialog(PRODUCT_BRAND_MODAL_ID),
        })
    }

    return (
        <BrandPickerDialog
            modalId={PRODUCT_BRAND_MODAL_ID}
            value={currentBrand}
            onSave={handleSave}
            isSaving={isPending}
            error={isError ? error : undefined}
        />
    )
}
